import { ClientDeatils } from './Client';

export const data: ClientDeatils[] = [
  {
    id: '9s41rp',
    name: 'Kelvin',
    address: 'Langosh',
    address2: 'Langosh',
    zipCode: '564321',
    mail: 'Jerod14@hotmail.com',
    state: 'Ohio',
    country: 'IN',
    phone: '9876521780'
  },
  {
    id: '08m6rx',
    name: 'mohan',
    address: 'Langosh',
    address2: 'Langosh',
    zipCode: '564321',
    mail: 'Jerod14@hotmail.com',
    state: 'Ohio',
    country: 'IN',
    phone: '9876521780'
  },
];

//50 us states array
export const states = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  'Puerto Rico',
];
